import axios from 'axios'
import urls from './urls'
import querystring from 'querystring'

/**
 * fetch driver list
 * @param {Object} filters
 *  @param {Number} filters.page Page number
 *  @param {Number} filters.size list size
 *  @param {String} filters.sort sort by (<field>, Asc|Desc)
 *  @param {String} filters.name search text
 */
const fetchDriverList = async function (filters) {
  console.log('TCL: filters', filters)
  try {
    let res = await axios.get(urls.driverList + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * fetch a driver's detail
 * @param {Number} userId drivers userID
 */
const fetchDriverDetail = async function (userId) {
  try {
    let res = await axios.get(urls.driverDetail + '/' + userId)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * create and edit Driver
 * @param {Object} form submitted form
 * @param {String} form.name driver name
 * @param {Number} form.length driver length
 * @param {Number} form.width driver width
 * @param {Number} form.height driver height
 * @param {Number} form.volume driver volume
 * @param {Number} form.maxWeight driver maxWeight
 * @param {String} form.imageUrl driver imageUrl
 * @param {Number} [userId] Transport Type Id
 */
const createEditDriver = async function (form, userId) {
  try {
    let res
    if (!userId) {
      res = await axios.post(urls.driverDetail, form)
    } else {
      res = await axios.put(urls.driverDetail + '/' + userId, form)
    }
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Set driver's activation status
 * @param {Number} userId Driver's userId
 * @param {Number} clientId Driver's company client ID
 * @param {Number} isActive set the driver's activation in binary boolean (1|0)
 */
const setDriverActivation = async function (userId, clientId, isActive) {
  try {
    let data = {
      clientId,
      userId,
      isActive
    }
    let res = await axios.post(urls.driverActivation, data)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

const deleteDriver = async function (userId) {
  try {
    let res = await axios.delete(urls.driverDelete + '/' + userId)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

export {
  fetchDriverList,
  createEditDriver,
  fetchDriverDetail,
  setDriverActivation,
  deleteDriver,
}
